import Entity from './entity';

export default class Template extends Entity<number> {
    public templatename: string;
    public shopid: string;
    public templateclass: number;
}
